import edit from './edit.js';
import softDelete from './soft-delete';

export default {
  edit,
  softDelete,
};
